<!-- @format -->
<button
	hmf-button
	class="favorites-icon-button"
	[class.filled]="productIsFavorited()"
	[title]="favoritesButtonAriaLabel()"
	[label]="favoritesButtonAriaLabel()"
	[disabled]="disabled()"
	[variant]="'secondary'"
	[size]="'medium'"
	[shape]="'circular'"
	[icon]="iconName()"
	[iconSize]="'large'"
	(click)="iconClicked()">
</button>
